import { useParams } from 'react-router-dom';

import {
  Autocomplete,
  TextField
} from '@mui/material';
import { useGlAccountAutocompleteQuery } from 'generated/graphql';
import { useMemo } from 'react';



export type GLAccountAutocompleteProps = {
  value?: string | null;
  onChange: (id: string | null) => void;
};

export const FC = (props: GLAccountAutocompleteProps) => {
  const { companyId } = useParams<{ companyId: string }>();
  const {
    data,
    loading
  } = useGlAccountAutocompleteQuery({
    skip: !companyId,
    variables: {
      listedCompanyId: companyId ?? ''
    }
  });



  const options = useMemo(() => {
    return data?.glAccountTypes.map((accountType) => {
      const foundAccount = data.standardGlAccounts.find((gl) => gl.name === accountType.name);
      return ({
        id: accountType.id,
        glAccountId: foundAccount?.id ?? '',
        label: foundAccount?.displayName ?? accountType.displayName
      });
    }) ?? [];
  }, [
    data?.glAccountTypes,
    data?.standardGlAccounts
  ]);



  const value = useMemo(() => {
    const foundValue = options.find((opt) => opt.glAccountId === props.value);
    return foundValue;
  }, [
    options,
    props.value
  ]);



  return (
    <Autocomplete
      size='small'
      disabled={loading}
      options={options}
      getOptionDisabled={(opt) => !opt.glAccountId}
      renderInput={(params) => <TextField required label='Search Company Data' {...params} />}
      value={value}
      getOptionLabel={(opt) => opt.label}
      getOptionKey={(opt) => opt.glAccountId || opt.id}
      onChange={(ev, value) => {
        if (value?.glAccountId ?? value === null) {
          props.onChange(value?.glAccountId ?? null);
        }
      }}
    />
  );
};
